var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-coloringtype": "fill",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.85 7.35V.5h1.3v6.85H16v1.3H9.15v6.85h-1.3V8.65H1v-1.3z"
})));
export default SvgPlus;